/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} ScoreInputs */

const fr_score = /** @type {(inputs: ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Score`)
};

/**

* @param {ScoreInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const score = /** @type {((inputs?: ScoreInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<ScoreInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_score(inputs)
});